<div class="page">
  <div class="page-sidebar">
    <div class="logo">Ruku na <span>Srce</span></div>
    <div class="menu">
      <ul *ngIf="menu">
        <li
          *ngFor="let item of menu.items"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <a [routerLink]="'/' + item.path">
            <i [class]="'fad ' + item.icon"></i>{{ item.title }}
          </a>

          <ul *ngIf="item.children">
            <li
              *ngFor="let childItem of item.children"
              routerLinkActive="active"
            >
              <a [routerLink]="'/' + childItem.path">{{ childItem.title }}</a>
            </li>
          </ul>
        </li>
      </ul>
    </div>

    <div class="user-menu">
      <ul>
        <li>
          <a href="javascript:;" (click)="openMyAccountDialog()">
            {{ 'myAccount' | translate }}
            <span class="user-email-address">{{ user?.email }}</span>
          </a>
        </li>
        <li>
          <a href="javascript:;" (click)="logout()">{{
            'logout' | translate
          }}</a>
        </li>
      </ul>
    </div>
  </div>

  <div class="page-body">
    <router-outlet></router-outlet>
  </div>
</div>
